var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3869 13.0104L3.34735 1.30589C2.58149 0.560961 1.33978 0.560961 0.574286 1.30589C-0.191266 2.05016 -0.191266 3.25729 0.574286 4.0015L11.2274 14.3582L0.574596 24.7145C-0.190956 25.459 -0.190956 26.6661 0.574596 27.4103C1.34015 28.1549 2.5818 28.1549 3.34766 27.4103L15.3872 15.7057C15.77 15.3334 15.9612 14.8459 15.9612 14.3582C15.9612 13.8703 15.7696 13.3825 15.3869 13.0104Z",
    fill: "#956D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowR);
export default __webpack_public_path__ + "static/media/arrowR.a669057067e0e164f1671a70b1a1293c.svg";
export { ForwardRef as ReactComponent };